module.exports = __webpack_public_path__ + "img/LOGO2.6cf6b33b.png";